/* global Swiper:false  */

(function () {
    "use strict";
    // swiper for testimonial

    let testimonailSwiper = null;
    const initTestimonailSwiper = () => {
        testimonailSwiper = new Swiper(".js-testimonial-container", {
            slidesPerView: 1,
            centeredSlides: false,
            autoplay: {
                delay: 3500, // duration of each slide in ms
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            loop: true,
            pagination: {
                el: ".js-testimonial-container .swiper-pagination",
                clickable: true,
            },
        });
    };

    const handleTestimonialSwiper = () => {
        if (
            !testimonailSwiper &&
            document.querySelector(".js-testimonial-container")
        ) {
            initTestimonailSwiper();
        }
    };

    //sort cards as per popularity
    function sortCardsBySupportedData() {
        const grid = document.querySelector(".grid-cards");
        const allCards = Array.from(grid.querySelectorAll(".connector-card"));

        // Check if allCards is an array and not empty before sorting
        if (Array.isArray(allCards) && allCards.length > 0) {
            allCards.sort(function (a, b) {
                const popularityA =
                    parseFloat(a.getAttribute("data-supportingdata")) || 0;
                const popularityB =
                    parseFloat(b.getAttribute("data-supportingdata")) || 0;
                return popularityB - popularityA;
            });
             
            // Append the sorted cards back to the grid
            allCards.forEach(function (card) {
                grid.appendChild(card);
            });
        }
    }
	sortCardsBySupportedData();

    // Search Bar
    const searchInput = document.getElementById("searchInput");
    const cards = document.querySelectorAll(".connector-card");

    searchInput.addEventListener("input", function () {
        const searchTerm = searchInput.value.toLowerCase();

        cards.forEach((card) => {
            const cardTitle = card.querySelector(".card-head");
            if (cardTitle) {
                const cardTitleText = cardTitle.textContent.toLowerCase();
                const displayStyle = cardTitleText.includes(searchTerm)
                    ? "block"
                    : "none";
                card.style.display = displayStyle;
            }
        });
    });

    // Filters
    const checkboxes = document.querySelectorAll('.source-checkboxes input[type="checkbox"]');

    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", filterCards);
    });

	function filterCards() {
		const selectedValues = [];
		const checkedNames = [];
	
		document
			.querySelectorAll('.source-checkboxes input[type="checkbox"]:checked')
			.forEach((checkbox) => {
				selectedValues.push(checkbox.value);
				checkedNames.push(checkbox.name);
			});
	
		const searchTerm = searchInput.value.toLowerCase();
		let anyCardVisible = false; // Flag to check if any card is visible
		cards.forEach((card) => {
			const dataRiskSources = checkedNames.map(
				(checkedName) => card.getAttribute(`data-${checkedName}`) || ""
			);
	
			const values = dataRiskSources.flatMap((source) =>
				source.includes(",") ? source.split(",") : [source]
			);
	
			const filterCondition =
				selectedValues.length === 0 ||
				values.some((value) => selectedValues.includes(value));
		
			const searchCondition =
				searchTerm === "" || cardMatchesSearch(card, searchTerm);
	
			const showCard = filterCondition && searchCondition;
	
			// Display "No Results" message if no card is visible
			card.style.display = showCard ? "block" : "none";
			if (showCard) {
				anyCardVisible = true; // Set the flag to true if any card is visible
			}
		});
		// Display "No Results" message if no card is visible
		const noResultsMessage = document.getElementById("noResultsMessage");
		if (!anyCardVisible) {
			noResultsMessage.style.display = "block";
		} else {
			noResultsMessage.style.display = "none";
		}
	}

    // Function to check if card matches search term
    function cardMatchesSearch(card, searchTerm) {
        const cardTitle = card.querySelector(".card-head");

        if (cardTitle) {
            const cardTitleText = cardTitle.textContent.toLowerCase();
            return cardTitleText.includes(searchTerm);
        }
        return false;
    }

	// Logic to hide Read more anchor and expand desc whose href is equal to #

	const connectorsWithReadMore = document.querySelectorAll(".connector-card a[href='#']");

	connectorsWithReadMore.forEach(function (connector) {
        connector.addEventListener('click', function (event) {
            event.preventDefault();
            const connectorCard = connector.closest('.connector-card');
            const descriptionElement = connectorCard.querySelector('.js-card-description');

            if (connectorCard && descriptionElement) {
                descriptionElement.classList.remove('line-clamp-3');
                connector.classList.replace('block', 'hidden');
            }
        });
    });

	// Logic to smooth Scroll to the explore all connectors

	document.addEventListener('click', function(event) {
		if (event.target.closest('#explore-button')) {
			event.preventDefault();
			var header = document.querySelector('.sticky');
			var targetSection = document.getElementById('explore-now');
			if (header && targetSection) {
				var headerHeight = header.offsetHeight;
				targetSection.style.paddingTop = headerHeight / 5 + 'px';
			}
			
			if (targetSection) {
				targetSection.scrollIntoView({ behavior: 'smooth' });
			}
		}
	});
	

    window.addEventListener("load", handleTestimonialSwiper);
    window.addEventListener("resize", handleTestimonialSwiper);
})();
